import { Fragment } from 'react'
import infoSys from 'assets/img/train/summer-institute.png'
import oceanside from 'assets/img/common/oceanside-community-foundation.png'

export const banner = {
  bannerTitle: 'AI will change',
  rotatingWords: [
    'Healthcare',
    'Finance',
    'Policymaking',
    'Conservation',
    'Defense',
    'Education',
    'Aerospace',
    'Entertainment',
  ],
  bannerSubTitle: 'Prepare your students to be responsible ai leaders',
  secondSubTitle: [
    'Artificial Intelligence Professional Development for K-12 Educators',
    'Virtual',
    <Fragment>
      <span className="font-seg-ui-reg">June 29 - July 3, 2026</span>
    </Fragment>,
  ],
  thirdSubTitle: (
    <Fragment>
      <span className="fs-26"><span className='font-seg-ui-bold'>FREE</span> - sponsored by </span>{' '}
      <img
        className="ml-20 bg-white p-10"
        style={{ maxWidth: 150 }}
        src={infoSys}
        alt="Info System"
      />
      {/* {' '}&amp;{' '}
      <img
        style={{ maxWidth: 80 }}
        src={oceanside}
        alt="Oceanside Community Foundation"
      /> */}
    </Fragment>
  ),
  buttons: [
    {
      isExternal: true,
      title: 'Create Account',
      link: 'https://pathfinders.onwingspan.com/web/en/login',
    },
    {
      isExternal: true,
      title: 'Register',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSc3e90kv9Yt35OZyOX5K0zBwmjA527mrJc0GkC_QPkFcMGDrw/viewform',
    },
  ],
  // afterButtonText: (
  //   <Fragment>
  //     *To register: create an account on the Pathfinders site. Next, click on
  //     the ‘register’ button & enroll in the course.
  //   </Fragment>
  // ),
}
